// screen/RedirectHandler.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getData } from "../utils/store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  USER_ID,
} from "../utils/store-data-constants";
import { get_profile_by_client_code } from "../api/serverWrapper";

const RedirectHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const userId = await getData(USER_ID);
      const agentLogin = await getData(AGENT_LOGIN);
      const clientLogin = await getData(CLIENT_LOGIN);
      if (userId) {
        if (agentLogin || clientLogin) {
          navigate("/dashboard", { replace: true });
        } else {
          const code = await getData(CLIENT_PROFILE_CODE);
          const resp = await get_profile_by_client_code(code);
          if (resp.data && resp.data.length > 0) {
            navigate("/profileforclient", { state: { client: resp.data[0] } });
          } else {
            navigate("/home");
          }
        }
      } else {
        navigate("/home"); // or wherever you want non-logged-in users to go
      }
    };

    checkUser();
  }, [navigate]);

  return navigate("/home"); // or a loading spinner
};

export default RedirectHandler;
